import {Injectable} from '@angular/core';
import {AccountResourceService} from '../../../shared/services/account-resource.service';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiConfig} from "../../../shared/services/api/config.api";
import {GENERAL_CONSTANTS} from '../../../shared/constants/constant';
import {SERVICE_CONSTANTS, API_CONSTANTS} from '../../../shared/constants/apiConstant';

@Injectable()
export class HomeService {
  constructor(public httpClient: HttpClient,
              public account: AccountResourceService) {
  }

  public webServiceUrl: string = ApiConfig.baseURL + SERVICE_CONSTANTS.WEB_SERVICE + GENERAL_CONSTANTS.SLASH;
  public authServiceUrl: string = ApiConfig.baseURL + SERVICE_CONSTANTS.AUTH_SERVICE + GENERAL_CONSTANTS.SLASH;

  getProfile(): any {
    const url = 'api/profile/info';
    return this.httpClient.get(ApiConfig.baseURL + url, {headers: ApiConfig.requestOptionsHeader});
  }

  getLogin(login: string, token?: string): any {
    const endpoint = API_CONSTANTS.ACCOUNT + GENERAL_CONSTANTS.SLASH + login;
    const url = this.webServiceUrl + endpoint;

    let headers = ApiConfig.requestOptionsHeader;
    if (token) {
      headers = headers.set("Authorization", token);
    }

    return this.httpClient.get(url, {headers: headers});
  }

  checkIfDeviceRegistered(token) {
    const endpoint = "account/device";
    const url = this.authServiceUrl + endpoint;

    const headers = new HttpHeaders().append("Authorization", token);
    return this.httpClient.get(url, { headers: headers });
  }

  registerDevice(token) {
    const endpoint = "account/device/register";
    const url = this.authServiceUrl + endpoint;

    const headers = new HttpHeaders().append("Authorization", token);
    return this.httpClient.post(url, {}, { headers: headers });
  }
}
